import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[luiButtonToggleLabel]',
    standalone: false
})
export class ButtonToggleLabelDirective {
  @HostBinding('class') hostClass = 'lui-button-toggle-label';
}
